import React from 'react';
import Aux from "../../HOC/Aux";
const Checkout =(props)=>{
    return(
        <Aux>
            <section className="comp-container container">
                <p>Hello from checkout page (testing)</p>
            </section>
            
        </Aux>
    )
}

export default Checkout;